import { gql } from '@apollo/client';

export const CREATE_OBJECT_GROUP_MUTATION = gql`
  mutation CreateObjectGroupMutation($group: ObjectGroupInput!) {
    createObjectGroup(group: $group) {
      ... on CreateObjectGroupSuccess {
        group {
          id
          createdAt
          createdBy
          name
          description
          shared
          level
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
